import React from 'react';
import Button from '../../ui/Button';
import AnimatedCounter from '../../ui/AnimatedCounter';
import AnimatedSection from '../../common/AnimatedSection';
import heroStatsData from '../../../data/heroStatsData.json';

export default function HeroSection() {
  const stats = heroStatsData;

  return (
    <AnimatedSection
      animation="fade-in"
      start="top 95%"
      duration={1}
      className="relative overflow-hidden w-full max-[984px]:rounded-none min-[985px]:rounded-[24px] min-[985px]:max-w-7xl min-[985px]:mx-auto min-[985px]:mt-0 max-[984px]:border-x-0 max-[984px]:border-t-0 min-h-[85dvh] p-6 sm:p-10 min-[985px]:p-10 mb-12 flex flex-col items-center justify-between shadow-acem-sm border border-acem-border/60"
    >
      <style>{`
        @keyframes subtleBounce {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-4px); }
        }
      `}</style>

      {/* Background container (Image de fond + dégradé noir) */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden max-[984px]:rounded-none min-[985px]:rounded-[24px]">
        {/* Fond image + voile dégradé sombre */}
        <img
          src="/img_AG.jpeg"
          alt=""
          className="absolute inset-0 w-full h-full object-cover object-center"
          aria-hidden="true"
        />
        <div
          className="absolute inset-0 bg-gradient-to-t from-black/95 via-black/40 to-black/60"
          aria-hidden="true"
        />
      </div>

      {/* Content (Centré verticalement et horizontalement pour toutes les tailles d'écran) */}
      <div className="flex-1 w-full max-w-3xl text-center mx-auto relative z-10 space-y-5 py-6 sm:py-8 flex flex-col items-center justify-center">
        <h1 className="font-title text-3xl sm:text-4xl md:text-5xl font-extrabold text-white leading-[1.15] tracking-tight drop-shadow-md">
          Bienvenue sur la plateforme <span className="text-acem-accent">ACEM Fès</span>
        </h1>
        <p className="text-base sm:text-lg text-white/90 leading-relaxed max-w-2xl mx-auto drop-shadow-sm">
          L'Association des Comoriens Étudiant au Maroc, section régionale de Fès vous accompagne dans vos démarches administratives, académiques et associatives.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-3.5 pt-2">
          <Button to="/inscription" variant="primary" size="lg">
            Rejoindre l'ACEM
          </Button>
          <Button
            to="/etudes/guide-inscription"
            variant="secondary"
            size="lg"
            className="bg-white/20 text-white border-white/30 hover:bg-white/30"
          >
            Espace Études
          </Button>
        </div>
      </div>

      {/* Cartes statistiques animées dans la Hero Section - Hauteur réduite & rebond subtil */}
      <div className="relative z-10 w-full max-w-5xl mx-auto pt-2 grid grid-cols-2 lg:grid-cols-4 gap-2.5 sm:gap-3.5">
        {stats.map((stat, idx) => (
          <div
            key={idx}
            className="bg-white/20 border-white/30 hover:bg-white/30 backdrop-blur-md border hover:border-acem-accent/60 rounded-xl sm:rounded-2xl py-2 px-3 sm:py-2.5 sm:px-3.5 text-center shadow-md transition-all duration-300 hover:scale-[1.03] group"
            style={{
              animation: 'subtleBounce 3.5s ease-in-out infinite',
              animationDelay: `${idx * 0.35}s`,
            }}
          >
            <div className={`font-title text-xl sm:text-2xl lg:text-3xl font-extrabold ${stat.color} leading-tight mb-0.5 drop-shadow-sm`}>
              <AnimatedCounter end={stat.end} suffix={stat.suffix} />
            </div>
            <h3 className="text-xs sm:text-xs font-bold text-white leading-tight mb-0.5">
              {stat.label}
            </h3>
            <p className="text-[10px] text-white/75 leading-tight line-clamp-1">
              {stat.desc}
            </p>
          </div>
        ))}
      </div>
    </AnimatedSection>
  );
}

